import React from 'react'
import { useNavigate } from 'react-router'
import { EmbedRenderer } from './EmbedRenderer'
import TagsCollection from './PopularTags'
const humanizeDuration = require("humanize-duration");

export const Meta = (props) => {
    return (
        <div className='flex aic' style={{ gap: 20, fontWeight: 600, opacity: .9, textAlign: "center", ...props.style }}>
            {props.expiryDate !== false
                ? <div className='flex aic expendableMeta' style={{ gap: 10 }}>
                    <svg width="20" height="20" viewBox="0 0 15 15" fill="#000" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.1531 4.84688C9.41875 4.11563 8.45937 3.75 7.5 3.75V7.5L4.84688 10.1531C6.3125 11.6188 8.68437 11.6188 10.15 10.1531C11.6156 8.6875 11.6156 6.3125 10.1531 4.84688V4.84688ZM7.5 1.25C4.04687 1.25 1.25 4.04687 1.25 7.5C1.25 10.9531 4.04687 13.75 7.5 13.75C10.9531 13.75 13.75 10.95 13.75 7.5C13.75 4.04687 10.9531 1.25 7.5 1.25ZM7.5 12.5C4.7375 12.5 2.5 10.2625 2.5 7.5C2.5 4.7375 4.7375 2.5 7.5 2.5C10.2625 2.5 12.5 4.7375 12.5 7.5C12.5 10.2625 10.2625 12.5 7.5 12.5Z" fill="#4D4D4D" />
                    </svg>
                    <p>{Date.now() > props.expiryDate ? "Expired" : "Expires in " + humanizeDuration(new Date(props.expiryDate).getTime() - Date.now(), { units: ["d"], round: true })}</p>
                </div>
                : null
            }
            <div className='flex aic expendableMeta' style={{ gap: 10 }}>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="#212121" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V18C1 18.55 1.45 19 2 19H14C14.55 19 15 18.55 15 18V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C15.05 13.06 15.06 13.08 15.07 13.09C16.21 13.92 17 15.03 17 16.5V18C17 18.35 16.93 18.69 16.82 19H22C22.55 19 23 18.55 23 18V16.5C23 14.17 18.33 13 16 13Z" fill="#212121" />
                </svg>
                <p>{props.votersCount} voters</p>
            </div>
            {props.type !== "slider"
                ? <div className='flex aic expendableMeta' style={{ gap: 10 }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="#212121" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM9.29 16.29L5.7 12.7C5.31 12.31 5.31 11.68 5.7 11.29C6.09 10.9 6.72 10.9 7.11 11.29L10 14.17L16.88 7.29C17.27 6.9 17.9 6.9 18.29 7.29C18.68 7.68 18.68 8.31 18.29 8.7L10.7 16.29C10.32 16.68 9.68 16.68 9.29 16.29Z" fill="#212121" />
                    </svg>
                    <p>{props.optionsCount} options</p>
                </div>
                : null
            }
            <div className='flex aic' style={{ gap: 10 }}>
                <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none" /><path d="M6.4 9.2h.2c.77 0 1.4.63 1.4 1.4v7c0 .77-.63 1.4-1.4 1.4h-.2c-.77 0-1.4-.63-1.4-1.4v-7c0-.77.63-1.4 1.4-1.4zM12 5c.77 0 1.4.63 1.4 1.4v11.2c0 .77-.63 1.4-1.4 1.4-.77 0-1.4-.63-1.4-1.4V6.4c0-.77.63-1.4 1.4-1.4zm5.6 8c.77 0 1.4.63 1.4 1.4v3.2c0 .77-.63 1.4-1.4 1.4-.77 0-1.4-.63-1.4-1.4v-3.2c0-.77.63-1.4 1.4-1.4z" /></svg>
                <p>{props.type.substring(0, 1).toUpperCase() + props.type.substring(1, props.type.length)} poll</p>
            </div>
        </div>
    )
}
export const FeedShell = (props) => {
    const navigate = useNavigate()
    return (
        <div onClick={() => navigate(`/${props.private ? "pvt/poll" : "poll"}/${props.id}`, {
            state: {
                ...props // Passing all the poll info for caching purposes
            }
        })} style={{ position: "relative", marginBottom: 20 }}>
            <div className='pollShell flex fdc jcsb'>
                <div className='flex jcsb extendedMetaTags'>
                    <div className='pollPageTagContainer'>
                        <TagsCollection tags={[
                            ...props.tags
                        ]} />
                    </div>
                </div>
                <div className='flex aic jcsb' style={{}}>
                    <div className='flex fdc' style={{ flex: 1 }}>
                        <h2 style={{ margin: "10px 0px", marginBottom: 10 }}>{props.title}</h2>
                        <p style={{ opacity: .6, fontWeight: 600, marginTop: 0, marginBottom: 30 }}>
                            {props.description.length > 100 ? props.description.substring(0, 100) + "..." : props.description}
                        </p>
                    </div>
                    <svg className='pollArrow' xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="20px" viewBox="0 0 24 24" width="20px" fill="#0074D9"><g><path d="M0,0h24v24H0V0z" fill="none" /></g><g><polygon points="6.23,20.23 8,22 18,12 8,2 6.23,3.77 14.46,12" /></g></svg>
                </div>
                <EmbedRenderer poll={{ ...props }} />
                <div style={{ marginTop: 25, paddingBottom: 20 }}>
                    <Meta {...props} />
                </div>
            </div>
        </div>
    )
}
